module.exports = __webpack_public_path__ + "static/media/crapppyGreenhouseSlideshow.28a2d4d5.gif";